import { Route, Switch } from "wouter";
import { HomePage } from "./pages/HomePage";
import { CreateProjectPage } from "./pages/CreateProjectPage";
import { ProjectDetailPage } from "./pages/ProjectDetailPage";
import { CollectionDetailPage } from "./pages/CollectionDetailPage";
import { CustomPromptPage } from "./pages/CustomPromptPage";
import { LifeKLinePage } from "./pages/LifeKLinePage";
import { LoginPage } from "./pages/LoginPage";
import { AuthGuard } from "./components/AuthGuard";
import "./index.css";

export function App() {
  return (
    <Switch>
      {/* Public routes */}
      <Route path="/login" component={LoginPage} />
      
      {/* Protected routes */}
      <Route path="/">
        <AuthGuard>
          <HomePage />
        </AuthGuard>
      </Route>
      <Route path="/create">
        <AuthGuard>
          <CreateProjectPage />
        </AuthGuard>
      </Route>
      <Route path="/custom">
        <AuthGuard>
          <CustomPromptPage />
        </AuthGuard>
      </Route>
      <Route path="/lifekline">
        <AuthGuard>
          <LifeKLinePage />
        </AuthGuard>
      </Route>
      <Route path="/projects/:id">
        <AuthGuard>
          <ProjectDetailPage />
        </AuthGuard>
      </Route>
      <Route path="/collections/:id">
        <AuthGuard>
          <CollectionDetailPage />
        </AuthGuard>
      </Route>
      
      {/* 404 fallback */}
      <Route>
        <div className="min-h-screen bg-background flex flex-col items-center justify-center">
          <h1 className="text-4xl font-bold text-foreground mb-4">404</h1>
          <p className="text-muted-foreground mb-6">页面不存在</p>
          <a
            href="/"
            className="px-6 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90"
          >
            返回首页
          </a>
        </div>
      </Route>
    </Switch>
  );
}

export default App;

